import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IAppState } from "../../../redux/reducers";
import MoreOptions from "../more-options";
import { IPopupMenuOption } from "../popup-menu";
import { iamEntityActions } from "redux/actions/iam-entity";
import { IIAMEntity } from "api/entities/iam-entity";
import { useNavigate } from "react-router-dom";

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>,
) => {
  return {
    openDeleteConfirmation: (id: string) =>
      dispatch(iamEntityActions.deleteConfirmation.open(id)),
  };
};

export interface IMoreOptionProps extends ReturnType<
  typeof mapDispatchToProps
> {
  data: IIAMEntity;
  systemManaged?: boolean | (() => boolean) | (() => Promise<boolean>);
  routeGetter: (id: string) => string;
}

export const MoreOption = connect(
  null,
  mapDispatchToProps,
)((props: IMoreOptionProps) => {
  const [options, setOptions] = useState<IPopupMenuOption[]>();
  const navigate = useNavigate();

  function openDeleteConfirmation() {
    props.openDeleteConfirmation(props.data.id);
  }

  async function getOptions(): Promise<IPopupMenuOption[]> {
    const result = [
      {
        label: "Manage",
        onClick: () => navigate(props.routeGetter(props.data.id)),
      },
    ];
    let canDelete: boolean = false;
    switch (typeof props.systemManaged) {
      case "boolean":
        canDelete = !props.systemManaged;
        break;
      case "function":
        const result = props.systemManaged();
        if (result instanceof Promise) {
          canDelete = !(await result);
        } else {
          canDelete = !result;
        }
      default:
        break;
    }
    if (canDelete) {
      result.push({
        label: "Delete",
        onClick: openDeleteConfirmation,
      });
    }

    return result;
  }

  useEffect(() => {
    getOptions().then((options) => setOptions(options));

    // eslint-disable-next-line
  }, []);

  return <MoreOptions options={options} />;
});
